<div style="display: flex;margin-left: -13px;margin-top: -27px;">
  <div style="margin-right: 30px;">
    <div>
      <mat-slide-toggle color="primary" labelPosition="before" [(ngModel)]="viewModel.runIngestDuration" (change)="validateField()">Perform Duration Calc</mat-slide-toggle>
    </div>
  </div>

  <div style="margin-right: 10px; margin-top: 5px;margin-left: -35px;">
    <div>
      <mat-form-field style="width: 200px;" appearance="outline">
        <mat-label>Event start field</mat-label>
        <mat-select [(ngModel)]="viewModel.eventStartField">
          <mat-option *ngFor="let col of eventStartFields" [value]="col">{{col}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>  

  <div style="margin-right: 10px;margin-left: -10px;">
    <div>
      <span class="svg-plus">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
  </div>

  <div style="margin-right: 10px;margin-left: -10px;">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Duration fileld</mat-label>
        <mat-select  [(ngModel)]="viewModel.durationField">
          <mat-option *ngFor="let col of durationFields" [value]="col">{{col}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field appearance="outline">
        <mat-label>Duration field units</mat-label>
          <mat-select [(ngModel)]="viewModel.durationUnits">
            <mat-option *ngFor="let type of DurationUnitTypes" [value]="type">
                {{DurationUnitsUtil.toString(type)}}
            </mat-option>
          </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div style="margin-right: 10px;margin-left: -10px;">
    <div>
      <span class="svg-equals">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 9H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 15H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
  </div>

  <div style="margin-right: 10px;margin-left: -10px;">
    <div>
      <mat-form-field style="width: 200px;" appearance="outline">
        <mat-label>Event end field</mat-label>
        <mat-select [(ngModel)]="viewModel.eventEndField">
          <mat-option *ngFor="let col of eventStartFields" [value]="col">{{col}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- <div style="margin-right: 10px;">
    <div>
      <mat-form-field style="margin-left: 5%;" appearance="legacy">
        <mat-label>Sort By</mat-label>
        <mat-chip-list #chipList aria-label="Sort By">
            <mat-chip *ngFor="let sortInfo of viewModel.sortInfo" (removed)="removeSortInfo(sortInfo)">
                {{sortInfo.sortField}}
                <mat-icon class="primary-color-icon" style="font-size: 8px"
                    *ngIf="sortInfo.sortAscending" style="margin-left: 3px;">
                    keyboard_arrow_down
                </mat-icon>
                <mat-icon class="primary-color-icon" style="font-size: 8px"
                    *ngIf="!sortInfo.sortAscending" style="margin-left: 3px;">
                    keyboard_arrow_up
                </mat-icon>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
            <input style="cursor: pointer;" [readonly]="true" (click)="showSortBuilder()" matInput
                placeholder="Edit Columns..." #sortInfoInput [formControl]="sortCtrl"
                [matChipInputFor]="chipList">
        </mat-chip-list>
    </mat-form-field>
    </div>
  </div> -->
</div>